import { memo, useState, cloneElement, FunctionComponent, ReactElement } from 'react';
import cn from 'classnames'
import { IconHalfStart, IconFullStart, IconEmptyStart } from './rating.icons'
import { RatingProps } from './rating.inteface'
import './rating.style.scss'

export const RatingComponent = (props: RatingProps) => {
  const {
    emptyIcon = <IconEmptyStart/>,
    halfIcon = <IconHalfStart/>,
    fullIcon = <IconFullStart/>,
    activeColor = '#ffc107',
    hoverColor = '#ffc107',
    color = '#ffd700',
    className,
    onChange,
    editable,
    isHalf,
    count,
    value,
    ...restProps
  } = props
  const [hoverValue, setHoverValue] = useState<number | undefined>(undefined)

  const handleMouseMove = (index: number) => {
    if (!editable) {
      return
    }
    setHoverValue(index)
  }

  const handleMouseLeave = () => {
    if (!editable) {
      return
    }
    setHoverValue(undefined)
  }

  const handleClick = (index: number) => {
    if (!editable) {
      return
    }
    if (onChange) {
      onChange(index + 1)
    }
  }

  const getColor = (index: number) => {
    if (hoverValue !== undefined) {
      if (index <= hoverValue) {
        return hoverColor
      }
    }
    if (value > index) {
      return activeColor
    }
    return color
  }

  const stars = []

  for (let i = 0; i < count; i++) {
    let star: ReactElement<HTMLDivElement>
    if (isHalf && value - i > 0 && value - i < 1) {
      star = halfIcon
    } else if (i < value) {
      star = fullIcon
    } else {
      star = emptyIcon
    }

    if (hoverValue !== undefined) {
      if (i <= hoverValue) {
        star = fullIcon
      }
    }

    stars.push(
      <span
        key={i}
        style={{ cursor: 'pointer' }}
        onMouseMove={() => handleMouseMove(i)}
        onMouseLeave={handleMouseLeave}
        onClick={() => handleClick(i)}
      >
        {cloneElement(star, {
          style: {
            ...star.props.style,
            color: getColor(i)
          },
        })}
      </span>,
    )
  }

  const classWrapper = cn('legion-rating', className)

  return (
    <div {...restProps} className={classWrapper}>
      {stars}
    </div>
  )
}

export const Rating = memo(RatingComponent as FunctionComponent<RatingProps>)
